<template>
  <div class="loading-bar-component-container">
    <div class="loading-bar" />
  </div>
</template>

<script>
  export default {

  };
</script>

<style lang='scss' scoped>
  $loading-bar-color: $blue-1 !default;
  $loading-bar-background-color: $blue-2 !default;

  @keyframes side2side {
    0%, 100% { transform: translateX(-50%); }
    50%      { transform: translateX(150%); }
  }

  .loading-bar-component-container {
    background: $loading-bar-background-color;
    height: 2px;
    margin: rem-calc(16) auto;
    overflow: hidden;
    position: relative;
    width: rem-calc(200);

    .loading-bar {
      animation: side2side 2s ease-in-out infinite;
      background: $loading-bar-color;
      height: 100%;
      position: absolute;
      width: 50%;
    }
  }
</style>
